import { createSlice } from "@reduxjs/toolkit";
import { KYC_STATUS_VARIANTS } from "constants/kycStatusVariants";

// This slice holds customer details of user who is doing KYC verification

export interface IGenericInformation {
  customerId: string;
  ownerName: string;
  shopName: string;
  mobileNumber: string;
  establishmentType: string;
  panDetails: PanDetails;
  bankDetails: BankDetails;
  kycStatus: (typeof KYC_STATUS_VARIANTS)[keyof typeof KYC_STATUS_VARIANTS];
}

export interface BankDetails {
  id: number;
  accountType: string;
  bankAccountNumber: string;
  bankName: string;
  bankAddress: string;
  bankTransactionRefNo: string;
  branchName: string;
  accountHolderName: string;
  userProvidedName: string | null;
  ifscCode: string;
  userNameMatchScore: string;
  accountProofDocumentUrl?:string;
}

export interface PanDetails {
  id: number;
  fullName: string;
  panNumber: string;
  panValidityStatus: string;
  panOperationalStatus: string;
  panIdHolderTitle: string;
  isCompliant: boolean;
  panAadhaarLinkStatus: string;
}

const GenericInformation = createSlice({
  name: "info",
  initialState: {
    kycDone: false,
    allData: {
      customerId: "",
      ownerName: "",
      shopName: "",
      mobileNumber: "",
      establishmentType: null,
      panDetails: null,
      bankDetails: null,
      kycStatus: KYC_STATUS_VARIANTS.PENDING,
    },
  },
  reducers: {
    setGenericInformation: (state, action) => {
      state.allData = action.payload;
    },
    setKycDone: (state, action) => {
      state.kycDone = action.payload as boolean;
    },
  },
});

// Export actions and reducer
export const { setGenericInformation, setKycDone } = GenericInformation.actions;
export default GenericInformation.reducer;
